<template>
  <div>
    <div v-if="$has('FWS-KJSH-FZSH-TGBH') && [1, 0, -3, -4].includes(current.approvalStatus)">
      <el-button
        class="table-button table-button-success"
        icon="el-icon-success"
        @click="handleOperateState(1, current)"
        :disabled="current.approvalStatus !== 1"
        v-track
        trackCode='approvalSubAccountList-5'
      >
        通过
      </el-button>

      <el-button
        class="table-button table-button-danger"
        icon="el-icon-delete-solid"
        @click="handleOperateState(2, current)"
        :disabled="current.approvalStatus !== 1"
        v-track
        trackCode='approvalSubAccountList-5'
      >
        驳回
      </el-button>
    </div>
    <!-- 确认/取消确认弹窗 -->
    <jr-operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="subAccountObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="setDivideApproval"
    />
  </div>
</template>

<script>
import { setDivideApproval } from '@/api/receivables/sub-account'; // setSubAccountBatchApproval

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '1',
    },
    multipleSelection: {
      type: Array,
      default: () => ([]),
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      subAccountObj: {}, // 分账审核对象
      textConfig: {}, // 弹窗页面提示文案
      isOperateStateShow: false, // 确认/驳回弹窗
      submitLoading: false,
    };
  },
  methods: {
    /**
     * 分账审核确认/驳回
     * divideNo     分账单编号
     * operation     操作：1、确认 2、驳回
     * cancelRemark  驳回原因，驳回时传入
    */
    handleOperateState(operation, row) {
      this.subAccountObj = {
        divideNos: [row.divideNo],
        operation,
        cancelRemark: '',
      };
      const list = {
        1: {
          title: '审核通过确认',
          messageTip: '是否通过该分账申请？',
          isPass: true,
        },
        2: {
          title: '审核驳回',
          messageTip: '驳回原因',
          isPass: false,
          required: false,
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    // 分账审核操作请求接口
    async setDivideApproval(params) {
      try {
        this.submitLoading = true;
        if (this.textConfig?.isBatch) { // 批量
          // await setSubAccountBatchApproval(params);
        } else {
          await setDivideApproval(params);
        }
        this.$message({
          message: '操作成功！',
          type: 'success',
        });
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.$emit('success');
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
  },
};
</script>
